import { render, staticRenderFns } from "./exp_M_sepelio.vue?vue&type=template&id=74ae5fb0"
import script from "./exp_M_sepelio.vue?vue&type=script&lang=js"
export * from "./exp_M_sepelio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports